import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import './PageHeader.css';

const PageHeader = ({ 
  title = "Page Title", 
  breadcrumb = [],
  backgroundImage = "https://images.unsplash.com/photo-1518432031352-d6fc5c10da5a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80",
  overlay = true,
  subtitle = "",
  height = "400px"
}) => {
  return (
    <section className="page-header" style={{ height }}>
      {/* Background Image */}
      <div 
        className="page-header-background"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        {/* Overlay */}
        {overlay && <div className="page-header-overlay"></div>}
        
        {/* Geometric Pattern Overlay */}
        <div className="page-header-pattern">
          <div className="pattern-grid">
            {Array.from({ length: 20 }, (_, i) => (
              <div key={i} className="pattern-line" style={{ 
                '--delay': `${i * 0.1}s`,
                '--rotation': `${i * 18}deg`
              }}></div>
            ))}
          </div>
        </div>

        {/* Floating Particles */}
        <div className="page-header-particles">
          {Array.from({ length: 8 }, (_, i) => (
            <div key={i} className={`particle particle-${i + 1}`}></div>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="page-header-content">
        <div className="container">
          <div className="page-header-inner">
            {/* Breadcrumb */}
            {breadcrumb.length > 0 && (
              <nav className="page-breadcrumb">
                <div className="breadcrumb-container">
                  {breadcrumb.map((item, index) => (
                    <React.Fragment key={index}>
                      {index === breadcrumb.length - 1 ? (
                        <span className="breadcrumb-current">{item.label}</span>
                      ) : (
                        <Link to={item.path} className="breadcrumb-link">
                          {item.label}
                        </Link>
                      )}
                      {index < breadcrumb.length - 1 && (
                        <ChevronRight className="breadcrumb-separator" size={16} />
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </nav>
            )}

            {/* Title */}
            <h1 className="page-header-title">{title}</h1>
            
            {/* Subtitle */}
            {subtitle && (
              <p className="page-header-subtitle">{subtitle}</p>
            )}

            {/* Decorative Elements */}
            <div className="page-header-decoration">
              <div className="decoration-line decoration-line-1"></div>
              <div className="decoration-dot"></div>
              <div className="decoration-line decoration-line-2"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Curved Bottom Border */}
      <div className="page-header-curve">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="curve-svg">
          <defs>
            <linearGradient id="curveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="var(--background-dark)" />
              <stop offset="50%" stopColor="var(--background-mid)" />
              <stop offset="100%" stopColor="var(--background-dark)" />
            </linearGradient>
          </defs>
          <path 
            d="M0,50 Q300,120 600,50 T1200,50 L1200,120 L0,120 Z" 
            fill="url(#curveGradient)"
            className="curve-path"
          />
        </svg>
        
        {/* Alternative Skewed Design */}
        <div className="skewed-overlay">
          <div className="skewed-section skewed-left"></div>
          <div className="skewed-section skewed-center"></div>
          <div className="skewed-section skewed-right"></div>
        </div>
      </div>

      {/* Glow Effects */}
      <div className="page-header-glow">
        <div className="glow-orb glow-orb-1"></div>
        <div className="glow-orb glow-orb-2"></div>
        <div className="glow-orb glow-orb-3"></div>
      </div>
    </section>
  );
};

export default PageHeader;